<form [formGroup]="copyForm">
  <h1 mat-dialog-title style="text-align:center;">Copying {{templateName}}</h1>
  <div style="display: flex;
  flex-direction: column;
  justify-content: space-evenly;">
    <p style="text-align: center; margin-bottom: 10px;">Enter a new name: </p><input formControlName='newName' type= text>
    <p style="text-align: center; margin-bottom: 10px;">Enter a new description: </p>
    <textarea  formControlName='newDesc' placeholder = "Add description here" type= text rows="4" style="width: 345px;margin: auto;"> </textarea>
  </div>
  <div style="position: relative;margin-top: 10px;top: 20px;left: 42px;width: 70%;">
    <button mat-button [mat-dialog-close]="copyForm.value"  style="position: relative;left: 50%;background: #ffffffaf;">Copy</button>
    <button mat-button (click)="dref.close()"  style="position: relative;left: 50%;background: #ffffffaf;">Close</button>
  </div>
  </form>
